import { logoutMutation } from '@/api/auth/authMutations';
import { currentUserQuery } from '@/api/user/userQueries';
import { HeaderWrapper } from '@/components/layout/HeaderWrapper';
import { routes } from '@/routes/routes';
import { ChevronDown as ChevronDownIcon } from '@carbon/icons-react';
import { useMutation, useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { DrawerClose } from '../common/Drawer';
import { Heading } from '../common/Heading';
import { Popover, PopoverContent, PopoverTrigger } from '../common/Popover';
import { HeaderDrawer } from './HeaderDrawer';

// TODO: Add links
const links = [
  {
    label: 'Our Supplements',
    href: routes.ingredients.index,
  },
  {
    label: 'Our Protocols',
    href: routes.protocols,
  },
  {
    label: 'Help',
    href: routes.help.index,
  },
];

export const Header = () => {
  const { data: user } = useQuery({
    ...currentUserQuery,
    retry: false,
  });
  const logout = useMutation(logoutMutation());

  return (
    <HeaderWrapper
      logoHref={user ? routes.dashboard.index : routes.home}
      desktopContent={
        <ul className="flex items-center gap-12">
          {links.map(({ label, href }) => (
            <li key={label}>
              <Link
                to={href}
                className="text-muted-foreground hover:text-foreground p-2 text-xl transition-colors"
              >
                {label}
              </Link>
            </li>
          ))}

          {!!user && (
            <li>
              <Popover>
                <PopoverTrigger
                  asChild
                  className="text-muted-foreground hover:text-foreground data-[state=open]:text-foreground flex items-center gap-1 p-2 text-xl transition-colors data-[state=open]:[&>svg]:rotate-180"
                >
                  <button>
                    {user.data.name}
                    <ChevronDownIcon className="size-4 transition-transform" />
                  </button>
                </PopoverTrigger>

                <PopoverContent
                  align="end"
                  className="w-fit min-w-40 px-0 py-2"
                >
                  <button
                    className="hover:bg-muted flex w-full items-center justify-start px-4 py-1"
                    onClick={() => logout.mutate()}
                  >
                    Log off
                  </button>
                </PopoverContent>
              </Popover>
            </li>
          )}
        </ul>
      }
      mobileContent={
        <HeaderDrawer logoHref={user ? routes.dashboard.index : routes.home}>
          {links.map(({ label, href }) => (
            <DrawerClose asChild key={label}>
              <Heading size="h3" asChild>
                <Link
                  to={href}
                  className="text-foreground hover:text-primary transition-colors"
                >
                  {label}
                </Link>
              </Heading>
            </DrawerClose>
          ))}

          <DrawerClose asChild>
            <Heading size="h3" asChild>
              <button onClick={() => logout.mutate()}>Log off</button>
            </Heading>
          </DrawerClose>
        </HeaderDrawer>
      }
    />
  );
};
